// src/lib/pages/TermsContent.tsx
const TermsContent = () => (
  <div className="max-w-3xl">
    <h3 className="text-3xl font-bold text-deepBlue">TERMS AND CONDITIONS</h3>
    <p className="mt-4 font-bold text-lg text-deepBlue">VISARO NIGERIA LIMITED</p>

    <p className="mt-4">
      By using our website, you are agreeing to be bound by these terms.
      <strong>IMPORTANT - PLEASE READ CAREFULLY.</strong>
    </p>

    <p className="mt-4">
      These Terms and Conditions (“Agreement”) govern the access to and use of the website, mobile applications, and services provided by Visaro Nigeria Limited (“Visaro”, “Company”, “we”, “us”, or “our”) through the platform located at www.visaro.ng (the “Platform”).
    </p>
    <p className="mt-4">
      Visaro Nigeria Limited is a company duly incorporated under the laws of the Federal Republic of Nigeria.
    </p>
    <p className="mt-4">
      The Platform provides technology infrastructure that facilitates Buy Now, Pay Later (BNPL) financing and related financial services, including credit assessment, merchant payment facilitation, and installment repayment management.
    </p>
    <p className="mt-4">
      By accessing or using the Platform, you agree to be bound by these Terms.
    </p>
    <p className="mt-4">
      If you do not agree with these Terms, you must not access or use the Platform.
    </p>

    <p className="mt-4">
      <strong>1. ELIGIBILITY</strong><br />
      You may only use the Platform if:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>You are at least 18 years old</li>
        <li>You have the legal capacity to enter into binding contracts</li>
        <li>You provide accurate and verifiable personal information</li>
      </ul>
      Visaro reserves the right to verify identity, perform KYC checks, and deny access where regulatory or risk requirements are not satisfied.
    </p>

    <p className="mt-4">
      <strong>2. SERVICES PROVIDED</strong><br />
      Visaro provides a digital financing platform that enables users to:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Purchase goods or services immediately</li>
        <li>Repay the cost in scheduled installments</li>
        <li>Access financing for approved merchant transactions, including travel services such as Fly Now, Pay Later</li>
      </ul>
      Visaro may also provide:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Credit risk assessment</li>
        <li>Payment facilitation to merchants</li>
        <li>Repayment monitoring</li>
        <li>Fraud prevention screening</li>
      </ul>
      Visaro does not operate as a Deposit Money Bank and does not accept deposits from the public.<br />
      Financial services offered through the Platform may involve regulated financial partners, payment processors, or licensed financial institutions in accordance with applicable Nigerian regulations.
    </p>

    <p className="mt-4">
      <strong>3. USER ACCOUNT REGISTRATION</strong><br />
      To access the Platform, you must create a User Account and provide:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Full legal name</li>
        <li>Valid email address</li>
        <li>Phone number</li>
        <li>Identification documents required for KYC</li>
      </ul>
      Users agree to:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Provide accurate and current information</li>
        <li>Maintain confidentiality of their login credentials</li>
        <li>Notify Visaro immediately in case of unauthorized account use</li>
      </ul>
      Visaro shall not be liable for losses resulting from user negligence or compromised login credentials.
    </p>

    <p className="mt-4">
      <strong>4. TRANSACTION FEES</strong><br />
      Users acknowledge that certain administrative and processing fees may apply to services offered on the Platform.
      <br />
      A non-refundable transaction processing fee of ₦2,000 (Two Thousand Naira) may be charged to cover:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Know Your Customer (KYC) verification</li>
        <li>Credit bureau checks</li>
        <li>Risk assessment and credit scoring</li>
        <li>Operational processing costs</li>
      </ul>
      This fee may be:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Charged during onboarding</li>
        <li>Deducted from the approved financing amount</li>
        <li>Charged separately during service processing</li>
      </ul>
      Visaro reserves the right to revise fees periodically, subject to applicable regulatory requirements.
    </p>

    <p className="mt-4">
      <strong>5. MERCHANT TRANSACTIONS</strong><br />
      Merchants listed on the Platform are independent third parties.
      <br />
      Visaro:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Facilitates payment and financing</li>
        <li>Does not manufacture, supply, or control the products or services sold by merchants</li>
      </ul>
      Users acknowledge that:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>The merchant is responsible for delivery, fulfillment, and service quality</li>
        <li>Disputes regarding goods or services must be resolved directly with the merchant</li>
      </ul>
      Visaro may assist in transaction mediation where appropriate but assumes no liability for merchant performance.
    </p>

    <p className="mt-4">
      <strong>6. USER RESPONSIBILITIES</strong><br />
      Users agree not to:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Provide false or misleading information</li>
        <li>Attempt to circumvent credit controls</li>
        <li>Use the Platform for fraudulent or unlawful activities</li>
        <li>Interfere with the security or operation of the Platform</li>
      </ul>
      Violation of these obligations may result in:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Account suspension</li>
        <li>Loan recall</li>
        <li>Legal enforcement</li>
      </ul>
    </p>

    <p className="mt-4">
      <strong>7. DATA PRIVACY AND NDPR COMPLIANCE</strong><br />
      Visaro is committed to protecting personal data in accordance with the Nigeria Data Protection Regulation (NDPR) and other applicable privacy laws.
      <br />
      By using the Platform, you consent to the collection, processing, storage, and sharing of your personal data for purposes including:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Identity verification</li>
        <li>Credit scoring</li>
        <li>Fraud prevention</li>
        <li>Loan servicing</li>
        <li>Regulatory compliance</li>
      </ul>
      Visaro may share user data with:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Licensed credit bureaus</li>
        <li>Financial institutions and payment processors</li>
        <li>Government regulators where legally required</li>
      </ul>
      All data processing activities are conducted in accordance with Visaro's Privacy Policy and applicable NDPR standards.
      <br />
      Users have the right to:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Request access to their personal data</li>
        <li>Request correction of inaccurate data</li>
        <li>Withdraw consent where legally permissible</li>
      </ul>
    </p>

    <p className="mt-4">
      <strong>8. REGULATORY COMPLIANCE</strong><br />
      Visaro operates in compliance with applicable laws and financial regulations of the Federal Republic of Nigeria, including:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Central Bank of Nigeria (CBN) regulations</li>
        <li>Nigeria Data Protection Regulation (NDPR)</li>
        <li>Anti-Money Laundering (AML) and Counter-Terrorism Financing (CTF) regulations</li>
        <li>Know Your Customer (KYC) requirements</li>
      </ul>
      Users agree to cooperate with any compliance checks or regulatory verification requests.
    </p>

    <p className="mt-4">
      <strong>9. SERVICE AVAILABILITY</strong><br />
      Visaro aims to maintain continuous access to the Platform, however services may be interrupted due to:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>System maintenance</li>
        <li>Security updates</li>
        <li>Technical failures</li>
        <li>Regulatory directives</li>
      </ul>
      Visaro shall not be liable for temporary service disruptions beyond its reasonable control.
    </p>

    <p className="mt-4">
      <strong>10. LIMITATION OF LIABILITY</strong><br />
      To the maximum extent permitted by law, Visaro shall not be liable for:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>Indirect or consequential damages</li>
        <li>Merchant-related disputes</li>
        <li>Service interruptions</li>
        <li>User misuse of the Platform</li>
      </ul>
      Total liability of Visaro shall not exceed the amount paid by the User for the relevant transaction.
    </p>

    <p className="mt-4">
      <strong>11. TERMINATION</strong><br />
      Visaro may suspend or terminate a user account if:
      <ul className="list-disc list-inside ml-4 mt-2">
        <li>These Terms are violated</li>
        <li>Fraud or misuse is suspected</li>
        <li>Regulatory obligations require such action</li>
      </ul>
      Users may terminate their account at any time by ceasing use of the Platform.
    </p>

    <p className="mt-4">
      <strong>12. GOVERNING LAW</strong><br />
      This Agreement shall be governed by and interpreted in accordance with the laws of the Federal Republic of Nigeria.
      <br />
      Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of Nigerian courts.
    </p>

    <p className="mt-4">
      <strong>13. CONTACT INFORMATION</strong><br />
      For inquiries regarding these Terms or the Platform, please contact:
      <br />
      Visaro Nigeria Limited<br />
      Website: <a href="http://www.visaro.ng" className="text-blue-500">www.visaro.ng</a><br />
      Email: <a href="mailto:support@visaro.ng" className="text-blue-500">support@visaro.ng</a>
    </p>
  </div>
);

export default TermsContent;
